import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Optional, Output, SimpleChanges } from '@angular/core';
import { LayoutService } from '@app/core/services/layout.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { BspRecordRight, BspService } from '@app/services/bsp.service';
import { UserGroupService, UserGroupTableEditGet } from '@app/services/user-group.service';

@Component({
    selector: 'tt-usergroup-table-edit',
    templateUrl: './usergroup-table-edit.component.html',
    styleUrls: ['./usergroup-table-edit.component.css'],
    standalone: false
})
export class UsergroupTableEditComponent implements OnInit, OnChanges {
    @Input()
    public p2UserGroupTableKeyno?: string | number;

    @Output()
    public onSave = new EventEmitter<void>();

    public page?: UserGroupTableEditGet;

    public recordRights: BspRecordRight[] = [];

    public saving = false;

    public error = '';

    public readonly tablet: MediaQueryList;

    private key?: string | number;

    private started = false;

    constructor(
        private readonly groups: UserGroupService,
        private readonly bsp: BspService,
        layout: LayoutService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator
    ) {
        this.navigator = useNavigatorFor(navigator, this);
        this.tablet = layout.getMediaQueries().tablet;
    }

    public async ngOnInit(): Promise<void> {
        if (this.started) return;

        this.key = this.p2UserGroupTableKeyno ?? this.navigator?.params['p2_usergroup_table_keyno'] as string | number | undefined;

        await this.loadPage();
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (!changes['p2UserGroupTableKeyno']) return;

        if (this.p2UserGroupTableKeyno) this.key = this.p2UserGroupTableKeyno;
        else if (this.key === undefined) this.key = this.navigator?.params['p2_usergroup_table_keyno'] as string | number | undefined;

        void this.loadPage();
    }

    private async loadPage(): Promise<void> {
        if (!this.key) return;

        this.started = true;

        try {
            await Promise.all([
                this.groups.getTableEdit({ p2_usergroup_table_keyno: this.key }).then(page => this.page = page),
                this.bsp.listRecordRights().then(rights => this.recordRights = rights)
            ]);
        } catch (error) {
            this.showError(error);
        }
    }

    public async save(): Promise<void> {
        if (!this.page || this.saving) return;

        this.saving = true;

        try {
            await this.groups.saveTable(this.page);

            this.saving = false;

            if (this.onSave.observed && this.tablet.matches) this.onSave.emit();
            else this.navigator?.back();
        } catch (error) {
            this.showError(error);
        } finally {
            this.saving = false;
        }
    }

    private showError(error: unknown): void {
        this.error = error instanceof Error ? error.message : String(error);
    }
}
